export default __webpack_public_path__ + "static/media/home-freelancer-img-06.6fe083ff.jpg";